module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "small.31b16c60.png";